import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import EsimBannerImage from 'shared/images/esim_banner.svg'
import InsuranceBannerImage from 'shared/images/insurance_banner.png'
import { sendGtagEvent } from 'shared/lib/analytics'

import { TripBanner } from './ui/trip-banner'

import s from './styles.module.scss'

export const InsuranceBanner = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className={s.card}>
      <p className={clsx('semi-bold-17', s.title)}>
        {t('insurance_info.trip_title')}
      </p>

      <div className={s.banners}>
        <TripBanner
          className={s.insurance}
          title={t('insurance_info.banner_title')}
          subtitle={t('insurance_info.banner_subtitle')}
          buttonText={t('insurance_info.banner_button')}
          decoration={
            <div className={s.insuranceImage}>
              <img
                src={InsuranceBannerImage}
                alt=""
              />
            </div>
          }
          onClick={() => {
            sendGtagEvent('VZR_SEARCH_BANNER_CLICK')
            navigate(RoutingPaths.insurance.path())
          }}
        />

        <TripBanner
          className={s.esim}
          title={t('insurance_info.esim_banner_title')}
          subtitle={t('insurance_info.esim_banner_subtitle')}
          buttonText={t('insurance_info.esim_banner_button')}
          decoration={
            <div className={s.esimImage}>
              <img
                src={EsimBannerImage}
                alt=""
              />
            </div>
          }
          onClick={() => {
            sendGtagEvent('ESIM_SEARCH_BANNER_CLICK')
            navigate(RoutingPaths.esim.path())
          }}
        />
      </div>
    </div>
  )
}
